// i18n area 'networks' — locale tr-TR (task #171, onda 5): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/networks.tr-TR.meta.json.
import type { enUS } from './networks'

export const trTR: typeof enUS = {
  networks: {
    common: {
      name: 'Ad',
      scope: 'Scope',
      operState: 'Durum',
      actions: 'Eylemler',
      create: 'Oluştur',
      close: 'Kapat',
      cancel: 'İptal',
      delete: 'Sil',
      edit: 'Düzenle',
      save: 'Kaydet',
      editError: 'Düzenleme başarısız oldu',
      search: 'Ada göre ara',
      empty: 'Burada henüz bir şey yok',
      saveError: 'Kaydedilemedi',
      loadError: 'Yüklenemedi — TVirt arka ucu erişilebilir mi?',
      createError: 'Oluşturma başarısız oldu',
      deleteError: 'Silme başarısız oldu',
      deleteConfirmTitle: '{name} silinsin mi?',
      deleteConfirmBody: 'Bu işlem geri alınamaz.',
      nameHint: 'Küçük harf, rakam ve tire (DNS-1123)',
      up: 'Etkin',
      down: 'Etkin değil',
      unknown: 'Bilinmiyor',
      usedByVMs: 'VM',
      emptyTable: 'Öğe yok — + düğmesiyle bir tane ekleyin'
    },
    dialogTabs: {
      general: 'Genel',
      base: 'Temel tanım',
      advanced: 'Gelişmiş yapılandırma',
      reserved: "TVirt'e ayrılan aralıklar",
      position: 'Konum',
      network: 'Ağ yapılandırması',
      hosts: 'Katılan düğümler'
    },
    reservedRanges: {
      note: "Bunlar, TVirt'e ayrılmış ve VM'lere, konteynerlere vb. otomatik olarak adres atamak için kullanabileceği IP aralıklarıdır. NOT: bu aralıklardaki IP'ler TVirt dışında harici hizmetler veya cihazlar tarafından kullanılmamalıdır.",
      from: 'Başlangıç',
      to: 'Bitiş'
    },
    overlay: {
      title: 'Overlay ağları',
      createTitle: 'Overlay ağı oluştur',
      editTitle: 'Overlay ağını düzenle',
      vni: 'VNI',
      vniHint: 'VXLAN Network Identifier — boş bırakılırsa otomatik atanır',
      subnet: 'Alt ağ',
      subnetHint: "Overlay'in CIDR'i — IPAM, kayıt girdisini bundan otomatik türetir",
      mtu: 'MTU',
      weight: 'Ağırlık',
      ceilMbps: 'Tavan (Mbps)',
      fairnessHint: 'Ağırlık yalnızca çekişme altında geçerlidir: boş bir bağlantıda her ağ tüm bant genişliğini kullanabilir. Tavan ise her zaman geçerlidir.',
      contention: 'Çekişme',
      contentionTip: 'En az bir düğüm bu ağın sınıfında kuyruk İLE birlikte düşürme veya overlimit gözlemliyor: uplink bant genişliği çekişmeli ve ağırlıklar etki ediyor. Ne kadar ve ne zamandan beri, düğümün net.shaping.* serilerinde.',
      firewallPolicy: 'Güvenlik duvarı politikası',
      hosts: 'Hostlar',
      hostsTitle: 'Katılan düğümler',
      hostsHint: "Her düğüm kendi underlay endpoint'ini bildirir — düğümün GERÇEK adresleri üzerinde bir seçim, ağ yapılandırmasından okunur; isteğe bağlı overlay adresi alt ağın içinde kalmalıdır. Katılım, placement kısıtıdır.",
      hostNode: 'Düğüm',
      hostUnderlay: 'Underlay IP',
      hostUnderlayPickNode: 'Önce düğümü seçin',
      hostAddress: 'Overlay adresi (isteğe bağlı)',
      hostAddressOutside: 'Overlay alt ağının dışında ({cidr})',
      addHost: 'Düğüm ekle',

      // Round #156 (dialog standard): dettagli osservati.
      observedAt: 'Gözlemlenme zamanı',
      attachedNics: "Takılı NIC'ler"
    },
    services: {
      title: 'Ağ hizmetleri',
      createTitle: 'Ağ hizmeti oluştur',
      editTitle: 'Ağ hizmetini düzenle',
      kind: 'Tür',
      kindCategory: 'Hizmetler',
      selectKindHint: "Hizmet türünü seçin — alttaki daemon, TVirt'in sizin için yönettiği bir gerçekleştirme ayrıntısıdır.",
      kindLabel: {
        dhcp: 'DHCP sunucusu',
        ntp: 'NTP sunucusu',
        vpn: 'VPN sunucusu',
        dns: 'DNS sunucusu',
        gateway: 'Ağ geçidi',
        'lb-rp': 'Load balancer ve reverse proxy',
        floatip: 'Yüzen IP'
      },
      kindDesc: {
        dhcp: "Sunulan alt ağlarda adres atar — havuzlar ağın alt ağından, ağ geçidinden ve TVirt'e ayrılan aralıklardan türetilir.",
        dns: "Bildirilen bölgeler üzerinde yetkili DNS — kayıtlar IPAM'den ve sizin manuel kayıtlarınızdan türetilir.",
        gateway: 'Düğüm bir ağ için ağ geçidi görevi görür — NAT (DNAT, 1:1, SNAT/masquerade) artı takılı ağlar arasında statik yönlendirme; tasarımı gereği kendi kendini onarır.',
        'lb-rp': "Hizmetlerinizin önünde load balancer / reverse proxy — üye havuzları ya da bir Pod'un hazır örnekleri üzerinde L4 veya L7 listener'lar, çalışırken yeniden yapılandırılır.",
        ntp: "Ağların zaman hizmeti — harici upstream sunucuların relay'i veya client'lara sunulan düğümün kendi saati.",
        vpn: "Düğüm üzerinde bir VPN yoğunlaştırıcısı — WireGuard veya OpenVPN, seçim sizin: gezici client'lar için uzaktan erişim ya da iki ağ arasında site to site tünel.",
        floatip: 'Aynı anda yalnızca tek bir sağlıklı App örneği ya da Pod üzerinde duran ve o düştüğünde bir sonraki sağlıklı hedefe taşınan tek adres — arka plan süreci olmadan failover; dengeleme yük dengeleyicide kalır.'
      },

      // Round Pod nativi P4: l'IP flottante (4b) e il backend Pod dell'lb-rp (4a).
      floatip: {
        hint: 'Yüzen IP, seçilen ağda tutucu örneğin kendi ad alanı içinde EK bir adres olarak yaşar: port yok, dengeleme yok, NAT yok — istemci IP\'si gerçek kalır.',
        address: 'Yüzen IP',
        targets: 'Hedefler',
        targetsHint: 'TERCİH sırasına göre: ilk sağlıklı hedef adresi tutar. Bir Pod, kopya sırasıyla tüm örnekleri demektir; her hedefin kendi sağlık ölçütü vardır. Her hedef aynı ağa bağlı olmalıdır.',
        targetKind: 'Hedef',
        targetApp: 'App örneği',
        targetPod: 'Pod (tüm örnekler)',
        targetRef: 'Hangisi',
        health: 'Sağlık',
        healthRunning: 'Çalışıyor (her konteyner hazır)',
        healthTcp: 'TCP bağlantısı',
        healthHttp: 'HTTP GET',
        healthPing: 'Ping',
        port: 'Port',
        path: 'Yol',
        addTarget: 'Hedef ekle',
        moveUp: 'Yukarı taşı',
        moveDown: 'Aşağı taşı',
        preempt: 'Preempt',
        preemptHint: 'Kapalı (varsayılan): sağlıklı tutucu, daha üstteki hedef geri dönse bile adresi korur — sallanma yok. Açık: ilk sağlıklı hedef her zaman tutar.',
        holder: 'Tutucu',
        noHolder: 'sağlıklı hedef yok',
        since: 'şu tarihten beri',
        verdicts: 'Gözlenen hedefler',
        healthy: 'sağlıklı',
        unhealthy: 'sağlıksız',
        noVerdict: 'Henüz karar verilmedi — yetkili düğüm ilk kararı bir sonraki geçişinde yazar.',
        vipChip: 'VIP {address}',
        vipChipTooltip: 'Bu örnek, {service} hizmetinin yüzen IP\'si {address} adresini tutuyor'
      },
      poolSource: 'Uç noktalar',
      poolSourceMembers: 'Statik üyeler',
      poolSourcePod: 'Bir Pod\'un hazır örnekleri',
      poolBackendPod: 'Pod',
      poolBackendPort: 'Port',
      poolBackendHint: 'Uç noktalar Pod\'u izler: bir örnek her konteyneri hazır olarak çalıştığında katılır, küçültüldüğünde veya öldüğünde hemen ayrılır. Etkin denetim varsayılan olarak açıktır.',
      poolBackendCount: '{pod} Pod\'unun {port} portundaki hazır örnekleri',
      node: 'Düğüm',
      enabled: 'Etkin',
      parked: 'Park edilmiş',
      subnets: 'Alt ağlar',
      subnetsHint: "Bu örneğin sunduğu IPAM alt ağları — havuzlar CIDR'den, ağ geçidinden ve TVirt'e ayrılan aralıklardan türetilir",
      noSubnets: 'IPAM alt ağı yok — önce bir fabric mantıksal ağı (veya bir overlay alt ağı) bildirin: IPAM bunlardan türetilir',
      iface: 'Dinleme arabirimi',
      ifaceHint: 'Hizmetin soketini üzerinde açtığı host arabirimi (örn. bir köprü) — zorunlu: bir ağ hizmeti kendi içinde bütündür, "tüm arabirimler" artık yok',
      dns: 'DNS sunucuları',
      domain: 'Etki alanı',
      detail: 'Sunduğu',
      subnetCount: '{n} alt ağ',
      zones: 'Bölgeler',
      zonesHint: "Yalnızca yetkili — daemon asla özyineleme yapmaz. A kayıtları, başvurulan IPAM alt ağlarındaki düğümlerin bildirilen adreslerinden türetilir; reverse anahtarı, karşılık gelen in-addr.arpa bölgelerini de sunar (PTR). Bir bölge, filo genelinde en fazla bir DNS örneği tarafından sunulur. İsteğe bağlı nameserver, NS/SOA kayıtlarına varsayılan ns.<bölge> yerine yazılan FQDN'dir; bölgenin içine düşerse A kaydı yine de sunan düğümden türetilir.",
      zoneName: 'Bölge adı',
      zoneNs: 'Nameserver (NS)',
      zoneSubnets: 'IPAM alt ağları',
      zoneReverse: 'Reverse (PTR)',
      zoneRecords: 'Manuel kayıtlar',
      zoneRecordsHint: 'Satır başına bir tane: ad TÜR değer — türler A, CNAME, MX, TXT. Ad çakışmasında manuel kayıt, türetilen kaydın önüne geçer.',
      addZone: 'Bölge ekle',

      // lb-rp (wave 3): listener su pool inline.
      lbListeningHint: 'Örnek TEK bir dinleme ağı ve TEK bir adres bildirir — her listener bu adresi kendi portuna bağlar; ikinci bir adres ikinci bir hizmettir.',
      listeners: "Listener'lar",
      listenersHint: 'Her listener, örneğin adresini kendi portunda L4 (TCP passthrough — baytlar asla açılmaz) veya L7 (HTTP) modunda bağlar ve aşağıdaki havuzlardan birine iletir. Bir adres/port çifti, düğüm başına en fazla bir örnek tarafından sunulur. Değişiklikler çalışırken uygulanır — yeniden başlatma yok, kopan bağlantı yok.',
      listenerName: 'Ad',
      listenerMode: 'Mod',
      modeL7: 'L7 — HTTP reverse proxy',
      modeL4: 'L4 — TCP passthrough',
      listenerPort: 'Port',
      listenerPool: 'Havuz',
      addListener: 'Listener ekle',
      pools: 'Havuzlar',
      poolsHint: 'Trafiğin indiği arka uçlar: round-robin veya en az meşgule göre dengelenen statik üyeler; isteğe bağlı etkin bir health check, hasta üyeleri rotasyondan çıkarır.',
      poolName: 'Ad',
      poolAlgorithm: 'Algoritma',
      algoRoundRobin: 'Round robin',
      algoLeastRequest: 'En az meşgul',
      poolCheck: 'Health check',
      checkNone: 'Yok',
      checkTcp: 'TCP bağlantısı',
      checkHttp: 'HTTP',
      poolCheckPath: 'Yoklama yolu',
      poolInterval: 'Aralık (s)',
      poolMembers: 'Üyeler',
      poolMembersHint: 'Satır başına bir tane: adres:port, isteğe bağlı olarak bir ağırlık (1-128) ile — örn. 10.0.0.21:8080 2',
      addPool: 'Havuz ekle',
      memberCount: '{n} üye',

      // ntp (round ntp, ratifica 2026-08-03) + #239 (netsvc autocontenuti):
      // editor condiviso dei listener per dns e ntp.
      listen: {
        assignment: 'Atama',
        assignmentStatic: 'Statik adres',
        assignmentAuto: 'Otomatik (TVirt ayrılmış aralıklar)',
        autoHint: 'TVirt adresi mantıksal ağın ayrılmış aralıklarından çeker ve sticky tutar — bir düzenlemede veya failover\'da asla yeniden çekilmez.',
        title: "Listener'lar",
        hint: 'Bir ağ hizmeti kendi içinde bütündür: her listener kendi ağını (overlay, fabric mantıksal ağı veya arabirim) ve alt ağının içinde bir adres bildirir — adres başına bir listener, wildcard artık yok. DNS ve NTP birden çok ağda ve o ağların birden çok adresinde dinleyebilir.',
        address: 'Dinleme adresi',
        add: 'Listener ekle'
      },
      ntp: {
        mode: 'Eşitleme modu',
        modeRelay: "Harici sunucuların relay'i",
        modeNodeClock: 'Düğümün kendi saati',
        modeHint: 'Relay, bildirilen upstream sunuculardan alınan saati sunar; düğümün kendi saati ise sunan düğümün saatini sunar — küme onu zaten eşitlenmiş tutar',
        servers: 'Upstream sunucular',
        serversHint: 'Virgülle ayrılır — hostname veya IP adresi; hizmet saati buradan alır ve ağa sunar',
        port: 'Dinleme portu',
        listening: 'Dinlediği yer'
      },

      vpn: {
        engine: 'Motor',
        engineHint: 'Seçim sizin ve bir daha değişmez: WireGuard modern, hızlı ve çekirdek içidir; OpenVPN uyumluluğun emektarıdır (TCP, zorlu ağlar)',
        engineLocked: 'Motor değiştirilemez — başka bir motor yeni bir hizmettir; anahtarlar ve sertifikalar taşınabilir değildir',
        mode: 'Mod',
        modeRemote: 'Uzaktan erişim',
        modeSite: 'Site to site',
        modeHint: "Uzaktan erişim, gezici client'lara tünelde bir adres verir; site to site iki ağı birleştirir",
        port: 'Dinleme portu',
        protocol: 'Taşıma',
        protocolWireguardHint: 'WireGuard yalnızca UDP konuşur',
        tunnelSubnet: 'Tünel alt ağı',
        tunnelSubnetHint: "Client'ların yaşadığı ağ — IPAM kayıt defterine kaydedilir; bu hizmetle birlikte doğar ve ölür",
        dnsServers: "Client'lara gönderilen DNS",
        routes: "Client'lara gönderilen rotalar",
        routesHint: 'Tünel üzerinden erişilebilen, virgülle ayrılmış ağlar; tünel alt ağı her zaman dahildir',
        peers: "Peer'lar",
        peersHint: 'Ortak anahtarı boş bırakın, TVirt çifti üretir — sonra profille birlikte teslim eder. Bir anahtar yapıştırın, peer kendi anahtarını korur.',
        clients: "Client'lar",
        clientsHint: "Her client, bu hizmetin kendi CA'sı tarafından verilen bir sertifika alır. Bir client'ı kaldırmak onu GEÇERSİZ KILAR: CRL hemen yeniden üretilir.",
        peerName: 'Ad',
        publicKey: 'Ortak anahtar',
        publicKeyMinted: 'TVirt üretir',
        peerAddress: 'Tünel adresi',
        peerAddressHint: 'Boş = atanır',
        allowedIps: 'Uzak alt ağlar',
        allowedIpsHint: 'Virgülle ayrılır, bu peer üzerinden yönlendirilir',
        endpoint: 'Endpoint',
        presharedKey: 'Önceden paylaşılan anahtar',
        keepalive: 'Keepalive (s)',
        addPeer: 'Peer ekle',
        addClient: 'Client ekle',
        auth: 'Kimlik doğrulama',
        authTls: 'Sertifikalar (TLS)',
        remote: 'Uzak endpoint',
        remoteHint: 'Uzak ucun host:port değeri — boş bırakılırsa bu taraf bekler',
        peerRoutes: 'Uzak alt ağlar',
        serverPublicKey: 'Bu sunucunun ortak anahtarı',
        ca: 'Sertifika yetkilisi',
        listening: 'Dinlediği yer',
        tunnel: 'Tünel',
        peerCount: '{n} peer',
        download: 'Profili indir',
        downloadError: 'Profil dışa aktarılamadı',
        lastHandshake: 'Son handshake',
        never: 'hiç',
        traffic: '↓ {rx} · ↑ {tx}',
        connected: 'Bağlı',
        idle: 'Boşta'
      },

      // Gateway (wave 3, ratifica 2026-08-01/03): famiglie NAT + rotte statiche.
      gateway: {
        attach: 'Dinleme ağı türü',
        attachOverlay: 'Overlay ağı',
        attachNetwork: 'Fabric mantıksal ağı',
        attachInterface: 'Ham arabirim',
        overlay: 'Overlay ağı',
        network: 'Mantıksal ağ',
        interface: 'Arabirim adı',
        interfaceHint: "TVirt'in yönetmediği bir host arabirimi — adres olduğu gibi kabul edilir",
        address: 'Dinleme adresi (ağ geçidi)',
        addressHint: "Client'ların yöneldiği ağ geçidi adresi — dinleme ağının alt ağı içinde",
        dnatTitle: 'DNAT kuralları',
        dnatHint: 'Hedef NAT: eşleşen trafik yeni bir adrese (ve isteğe bağlı olarak yeni bir porta) yönlendirilir. Listedeki herhangi bir protokol — portlar, protokolün onları taşıdığı yerde.',
        snatTitle: 'SNAT kuralları',
        snatHint: 'Kaynak NAT: eşleşen trafik, kaynağı yeniden yazılmış olarak çıkar — açık bir yeni adres (ve isteğe bağlı olarak yeni bir port) ya da boş bırakılırsa çıkış adresinde masquerade.',
        oneToOneTitle: '1:1 NAT kuralları',
        oneToOneHint: 'Dış adrese gelen her paket iç adrese eşlenir ve içteki host dışarıya dış adresle çıkar — tüm protokoller, her iki yön.',
        external: 'Dış adres',
        internal: 'İç adres',
        addOneToOne: '1:1 kuralı ekle',
        family: 'Aile',
        protocol: 'Protokol',
        source: 'Kaynak (adres/alt ağ)',
        destination: 'Hedef (adres/alt ağ)',
        invert: 'NOT',
        srcPorts: 'Kaynak portları',
        dstPorts: 'Hedef portları',
        dstPortsHint: 'Port veya aralık (80, 8000-8099)',
        toAddress: 'Yeni adres',
        toPort: 'Yeni port',
        snatTo: 'Yeni kaynak (boş = masquerade)',
        snatToHint: 'Açık kaynak adresi; boş = çıkış adresinde masquerade',
        addDnat: 'DNAT kuralı ekle',
        addSnat: 'SNAT kuralı ekle',
        routesTitle: 'Statik rotalar',
        routesHint: 'Düğüm, takılı olduğu ağlar arasında yönlendirme yapar (IP forwarding açık); bu rotalar onların ötesine erişilebilirlik ekler — saf kernel, dinamik yönlendirme sonraki bir round ile gelecek.',
        routeDestination: 'Hedef alt ağ',
        routeGateway: 'Next hop',
        routeMetric: 'Metrik',
        addRoute: 'Rota ekle',
        listening: 'Dinlediği yer',
        rules: '{d} DNAT · {o} 1:1 · {s} SNAT · {r} rota'
      },
      unknownSince: 'Bilinmiyor — son rapor {m} dk önce',
      lastWord: 'Son söz',

      // Round #156 (dialog standard): righe osservate + riepilogo kind.
      reportObservedAt: 'Son rapor',
      lastErrorRow: 'Son hata',
      recordsCount: '{n} manuel kayıt',
      phase: {
        configured: 'Yapılandırıldı',
        running: 'Çalışıyor',
        error: 'Hata'
      },
      authorityNode: 'Authority (atama)',
      preferredNode: 'Tercih edilen düğüm',
      preferredNodeHint: 'Yumuşak bir tercih, asla bir kısıt değil: bir sonraki placement kararında bu üye uygunsa örnek buraya iner — tek başına hiçbir şeyi taşımaz; hamle "Authority\'yi aktar"dır.',
      noPreference: 'Tercih yok (otomatik placement)',
      moving: 'Taşınıyor',
      movingTooltip: 'Authority {node} düğümünü atarken burada gözlemlendi: hamle yakınsıyor.',
      placement: {
        title: 'Placement',
        loading: 'Sayım sürüyor…',
        loadError: 'Placement sayımı yanıt vermedi — daha sonra yeniden deneyin.',
        draftHint: 'Sayım, bildirilen ağ bağlantısından hesaplanır: hizmet oluşturulunca görünür. Hiçbir üye hizmeti sunamıyorsa oluşturma reddedilir ve ret, uygun üye kümesini boşaltan mekanizmanın adını verir.',
        eligibleCount: '{m} üyeden {n} tanesi bu örneği sunabilir',
        recommended: 'Önerilen',
        eligible: 'Uygun',
        notEligible: 'Uygun değil',
        blockedReachability: 'ağ bu üyeye ulaşmıyor',
        blockedRequireTag: 'gerekli bir etiket engelliyor (requireNodes)',
        blockedExcluded: 'simülasyonun dışında bırakıldı',
        preferenceUnknown: '(artık) bir küme üyesi değil',
        preferenceIgnored: '"{node}" tercihi bugün uygun değil: {reason}. Sayımın önerisi geçerli olur — asla bir hata değil, hizmet başka yerde yaşar.',
        emptyReachability: 'Hiçbir üye bu örneği sunamıyor: ağ hiçbir yere ulaşmıyor — hiçbir etiket düzeltmesi yardımcı olmaz. Düğümü kablolayın ya da hizmeti ağın olduğu yere taşıyın.',
        emptyRequireTag: 'Hiçbir üye bu örneği sunamıyor: uygun üye kümesini boşaltan, gerekli etiketlerdir — requireNodes girdisini kaldırın ya da bir üyeyi etiketleyin.',
        spof: 'Tek hata noktası',
        spofDetail: 'Örneği yalnızca bir üye barındırabilir: arıza anında yük devretmenin gidecek yeri yok. Çok listener\'lı bir hizmet TEK PARÇA hâlinde taşınır — aday, TÜM ağlarını görebilmelidir: bedeli budur.',
        whatIf: 'Üye yokluğunu simüle et',
        whatIfHint: 'Boşaltmanın what-if\'i: tahliyeden ÖNCE sorun, yük devretme anında keşfetmeyin.',
        survives: '{nodes} yokken hizmetin hâlâ bir evi var.',
        notSurvives: '{nodes} tahliyesi bu hizmeti DEVRE DIŞI bırakır: türetilmiş kısıt erişilebilirliğe baskın gelir (R30) — ağın ulaşmadığı yerde canlı bir daemon kimseye hizmet etmez ve kimseyi alarma geçirmez.',
        transfer: 'Authority\'yi aktar',
        transferError: 'Aktarım başarısız oldu',
        transferTarget: 'Hedef üye',
        transferHint: 'Yalnızca uygun üyeler önerilir — geçerli kümenin içinde bir tercih, asla bir override değil. Görev yok: worker\'ların bir sonraki turu hamlenin TA KENDİSİDİR (eski düğüm biçer, yenisi kurar).'
      }
    },
    fabric: {
      tabDerivation: 'Türetme',
      importNetwork: 'Başka bir fabric’ten içe aktar',
      importTitle: 'Mantıksal ağ içe aktar',
      importHint: 'İçe aktarma açık katılımdır: ağ sahibinde kalır (aynı kimlik, aynı stem, aynı tvf-<stem> bridge) ve buradan bu fabric’in portlarına/LAGG’lerine eşlenir — eşlemek, teslimatın sahibinkiyle aynı L2 alanına çıktığını iddia etmek DEMEKTİR.',
      importPick: 'Sahibin ağı',
      importNone: 'İçe aktarılacak bir şey yok: diğer fabric’lerin bu fabric’in zaten tanımadığı kendi ağı yok',
      importedNetworksTitle: 'İçe aktarılan ağlar',
      noImported: 'İçe aktarılan ağ yok',
      importedFrom: '{fabric} fabric’inden içe aktarıldı',
      importedBy: 'İçe aktaranlar: {list}',
      importedCount: '+{n} içe aktarılan',
      owner: 'Sahip',
      bridge: 'Bridge',
      bond: 'Bond',
      unimport: 'İçe aktarımı kaldır',
      unimportConfirm: '{name} ağının (sahip {fabric}) içe aktarımı bu fabric’ten kaldırılsın mı? Bu fabric’in bir portu ya da LAGG’i onu eşlediği veya bir konuk, App ya da servis yalnızca bu bacak üzerinden hizmet aldığı sürece reddedilir.',
      unimportRefused: 'İçe aktarım hâlâ kullanımda — {detail}',
      deriv: {
        codeHint: {
          deviceHeldByFabric: 'Bu node o ağı zaten üyesi olduğu başka bir fabric’ten alıyor: bir node paylaşılan bir ağı yalnızca bacaklarından BİRİ üzerinden alır (aynı L2’nin iki uplink’i STP’siz bir bridge’de döngüdür). İki fabric’ten birinin portlarında ya da LAGG’inde eşlemeyi kaldır.',
          otherFabricDerived: 'Belge, node’un artık kablo bildirmediği bir fabric’in bloğunu taşıyor: önce o fabric’in planını uygula (cihazlarının kaldırılmasını önerir) ya da fabric artık yoksa take-ownership ile onları devral.'
        },
        hint: 'O.3 türetme planı: kablolanmış her node için durum, türetilmiş-vs-mevcut diff, BEYAN EDİLMİŞ bond topolojisi, dual-stack flipler ve yapılandırılmış retler/uyarılar. AÇIK apply\'a kadar salt okunur — hiçbir şey bir node\'a asla kendiliğinden inmez.',
        refresh: 'Planı yeniden yükle',
        empty: 'Bu fabric\'e kablolanmış node yok (ve hiçbiri artık onun bloğunu taşımıyor).',
        refusal: 'Ret',
        warning: 'Uyarı',
        generation: 'belge nesli {n}',
        state: {
          manual: 'Manuel',
          derived: 'Türetilmiş',
          diverged: 'Sapmış'
        },
        topologyTitle: 'Beyan edilmiş topoloji',
        members: 'üyeler',
        primary: 'birincil',
        held: 'TEK üyede tutuluyor',
        form: {
          perNetworkBond: 'Ağ başına bond',
          singleBond: 'Tek yedek bond',
          laggBond: 'LACP bond (LAGG)',
          singlePort: 'Tek port'
        },
        colAction: 'Eylem',
        colKind: 'Tür',
        colDevice: 'Device',
        colDetail: 'Ayrıntı',
        action: {
          add: 'ekle',
          remove: 'kaldır',
          replace: 'değiştir'
        },
        diffEmpty: 'Bekleyen diff yok — uygulanan belge render ile örtüşüyor.',
        diffBlocked: 'Diff yok: yukarıdaki retler bu node\'u engelliyor.',
        phasePlanned: 'planlandı (adım 1/3)',
        phaseDraining: 'boşaltılıyor (adım 2/3)',
        probeUnobserved: 'Boşaltma sondası: hiç raporlanmadı — boşluk BİLİNMİYOR (şimdi bir retire reddedilirdi).',
        probeFailed: 'Boşaltma sondası: gözlem BAŞARISIZ — bilinen zaman damgaları taşınır, kimsenin ölçmediği bir «boş» asla.',
        probeActive: {
          one: 'Sonda: eski adreste hâlâ {n} kurulu bağlantı',
          other: 'Sonda: eski adreste hâlâ {n} kurulu bağlantı'
        },
        probeLastActive: 'son etkinlik {time}',
        probeEmpty: {
          one: 'Sonda: {n} dakikadır boş',
          other: 'Sonda: {n} dakikadır boş'
        },
        probeEmptyUnknown: 'Sonda: boş (ne zamandan beri, bilinmiyor).',
        impact: 'Bu node\'daki {nics} vNIC ve {apps} App şu ağları kullanıyor: {list}',
        apply: 'Bu node\'a uygula',
        applyTitle: 'Türetmeyi uygula — {node}',
        applyIntro: 'Türetilmiş yapılandırma {node} node\'unun ağ belgesini yeniden yazar ({n} değişiklik), host-network editörüyle aynı kapıdan — NetworkManager checkpoint ve dürüst sonda dahil. Aşağıdaki plan uyarıları eylemle birlikte yolculuk eder: onaylamadan önce okuyun.',
        applyError: 'Apply başarısız',
        applyRefused: 'Node reddetti:',
        planMoved: 'Fabric bu önizlemeden sonra değişti — HİÇBİR ŞEY uygulanmadı. Plan yeniden yüklendi: tekrar bakın ve yeniden deneyin.',
        retire: 'Emekliye ayır',
        retireTitle: 'Geri dönüşü olmayan nokta — {address} emekliye ayrılıyor',
        restore: 'Geri yükle',
        restoreTip: 'Apply öncesi anlık görüntüye dön (nesil {previous}) — tek adımlık geri alma (H13)',
        restoreTitle: 'Önceki belgeyi geri yükle — {node}',
        restoreIntro: '{node} düğümünün ağ belgesi, son apply\'dan önce alınan anlık görüntüye ({previous}. nesil) döner ve {current} yerine {next}. nesil olarak yeniden yazılır. Worker onu diğer her belge gibi yakınsar.',
        restoreRedo: 'Değiştirilen belge yeni anlık görüntü olur: yeniden geri yüklemek redo\'dur.',
        restoreClosesChain: 'Anlık görüntü türetme öncesi manuel belgedir: zincir burada kapanır — başka geri alma yok, düğüm bir sonraki apply\'a kadar manuel kalır.',
        restoreConfirm: 'Geri yükle',
        restoreError: 'Geri yükleme başarısız',
        retireIntro: 'Bu, {address} adresini ({network}) {point} üzerinden kalıcı olarak kaldırır. Bu eylemden sonra geri dönüş yolu TERS fliptir — eski adresi aynı motor üzerinden yeniden beyan etmek — asla kör bir geri yükleme değil.',
        retireOld: 'Eski adres (kaldırıldı)',
        retireNew: 'Yeni adres (kalıyor)',
        retireEmptyFact: 'Boşaltma sondası adresi boş bildiriyor: bu kaldırma gözlemlenen hiçbir bağlantıyı kesmez.',
        retireConfirm: 'Adresi emekliye ayır',
        severActiveLoss: {
          one: 'Eski adreste hâlâ {n} kurulu bağlantıyı kes — bu eylemle ölür',
          other: 'Eski adreste hâlâ {n} kurulu bağlantıyı kes — bu eylemle ölürler'
        },
        severUnknownLoss: 'BİLİNMEYENİ kabul et: sonda bu adresi hiç gözlemlemedi (veya gözlem başarısız oluyor) — canlı bağlantılar kesilebilir.'
      },
      title: 'Fabric',
      createTitle: 'Fabric oluştur',
      networks: 'Ağlar',
      switches: 'Anahtarlar',
      ports: 'Portlar',
      laggs: "LAGG'ler",
      subnets: 'Alt ağlar',
      tabOverview: 'Genel bakış',
      tabNetworks: 'Mantıksal ağlar',
      tabSwitches: 'Anahtarlar',
      overviewHint: "Fabric tek bakışta: her mantıksal ağ MTU'su ve alt ağıyla (VLAN'lar yalnızca port başına/LAGG başına eşlemelerde yaşar — aynı ağ farklı portlarda farklı tag'lerle taşınabilir). Fabric, HARİCİ bir altyapının kaydıdır — TVirt gözlemler ve bildirir, asla provisioning yapmaz ve yalnızca kendi denetimine kaydedilmiş NIC'lere dokunur.",
      absorptionHint: 'Burada bildirilen her alt ağ, IPAM kaydındaki girdisini aynı yazma işleminde TÜRETİR — ağla birlikte yaşar ve ölür.',
      scopeFixedHint: 'Scope sabittir: küme kökü — fiziksel altyapı tanımı gereği küme genelindedir.',
      networksHint: "Her ağ zorunlu bir MTU (varsayılan 1500) ve zorunlu bir alt ağ taşır; burada bildirilen ağ geçidi, DNS sunucuları ve statik rotalar sunucu NIC'leri, App'ler ve ağ hizmetleri için TEK KAYNAKTIR.",
      switchesHint: 'Manuel kayıt: bir port ya kullanılmıyordur, ya eşlenmiştir (untagged ve VLAN tag başına trafik mantıksal ağlara) ya da bir LAGG üyesidir — üye kendi eşlemelerini taşımaz.',
      mtu: 'MTU',
      cidr: 'CIDR',
      cidrHint: 'Zorunlu — IPAM kayıt girdisini bundan otomatik türetir',
      nodeAddressing: 'Düğüm adresleme',
      nodeAddressingNone: 'Yok — düğüm başına adres yok',
      nodeAddressingPool: 'Pool — hizmet verilen her düğüme bir kalıcı adres',
      nodeAddressingHint: 'Pool ile fabric türetimi, hizmet verilen her düğüme TVirt için ayrılmış aralıklardan bir adres atar (atandıktan sonra kalıcı).',
      backing: 'Backing',
      gateway: 'Ağ geçidi',
      ranges: 'Ayrılmış aralıklar',
      dns: 'DNS sunucuları (virgülle ayrılır)',
      dnsShort: 'DNS',
      singleSourceHint: "Burada bildirilen ağ geçidi, DNS ve rotalar tek kaynaktır — sunucu NIC'leri, App'ler ve ağ hizmetleri buradan beslenir",
      routesTitle: 'Statik rotalar',
      routeDestination: 'Hedef (CIDR)',
      routeVia: 'Üzerinden (next hop)',
      portUsed: 'Kullanımda',
      vlanMappings: 'VLAN eşlemeleri',
      vlanTag: 'VLAN tag',
      vlanNetwork: 'Mantıksal ağ',
      nameTaken: "Bu ad fabric'te zaten kullanılıyor",
      addNetwork: 'Ağ ekle',
      editNetwork: 'Ağı düzenle',
      deleteNetwork: 'Ağı kaldır',
      deleteNetworkConfirm: "{name} mantıksal ağı fabric'ten kaldırılsın mı? IPAM'deki türetilmiş alt ağı onunla birlikte ölür (bir hizmet veya App onu kullandığı sürece reddedilir). Ona işaret eden port ve LAGG eşlemeleri temizlenir.",
      switchName: 'Anahtar',
      portName: 'Port',
      positionHint: 'Fiziksel konum (isteğe bağlı) — sunucu yerleşimiyle aynı sözcük dağarcığı; yalnızca bildirimseldir',
      addSwitch: 'Anahtar ekle',
      editSwitch: 'Anahtarı düzenle',
      deleteSwitch: 'Anahtarı kaldır',
      deleteSwitchConfirm: "{name} anahtarı tüm portlarıyla birlikte kaldırılsın mı? LAGG'ler buna göre küçülür (ve iki portun altına inince ölür).",
      addPort: 'Port ekle',
      editPort: 'Portu düzenle',
      deletePort: 'Portu kaldır',
      deletePortConfirm: '{name} portu kaldırılsın mı?',
      untagged: 'Untagged',
      tagged: 'Tagged (tag:ağ)',
      taggedShort: 'Tagged',
      portCabling: 'Kablolama',
      portState: 'Durum',
      stateUnused: 'kullanılmıyor',
      stateMapped: 'eşlenmiş',
      laggPortGuard: 'LAGG üyesi bir port, LAGG tarafında düzenlenir',
      laggsTitle: "LAGG'ler",
      laggsHint: "Bir LAGG, LACP'de 2+ porttur ve anahtarları aşabilir (MLAG, saydam); yalnızca kullanılmayan portlar katılır, eşleme yüzeyi LAGG'dir, kaldırılan bir port kullanılmıyor durumuna döner.",
      addLagg: 'LAGG ekle',
      editLagg: "LAGG'i düzenle",
      deleteLagg: "LAGG'i kaldır",
      deleteLaggConfirm: "{name} LAGG'i kaldırılsın mı? Üye portları kullanılmıyor durumuna döner.",
      lacpRate: 'LACP rate',
      laggPorts: 'Üye portlar (2+)',
      laggPortsHint: 'Yalnızca kullanılmayan portlar katılabilir — eşlenmiş bir portu önce serbest bırakın',
      noNetworks: 'Bildirilmiş mantıksal ağ yok.',
      noSwitches: 'Bildirilmiş anahtar yok.',
      noLaggs: 'Bildirilmiş LAGG yok.',
      staleConflict: "Sen düzenlerken başka bir operatör bu fabric'i değiştirdi: onun işi silinmesin diye kayıt reddedildi. Değişikliklerin hâlâ burada, olduğu gibi duruyor. Güncel fabric zaten yeniden yüklendi: üzerine yeniden uygulamak için tekrar onayla ya da iptal et ve neyin değiştiğine bak."
    },
    ipam: {
      title: 'IPAM',
      derivedHint: "Yalnızca türetilmiş: her alt ağ bir fabric mantıksal ağından veya bir overlay'den doğar — kaynağında düzenlenir. Atanmış adresler onları KİMİN tuttuğunu gösterir; TVirt'e ayrılan aralıklar otomatik atamanın havuzlarıdır.",
      search: 'Ada, CIDR\'ye veya adrese göre ara',
      empty: 'Ağ yok — bir fabric mantıksal ağı veya bir overlay alt ağı bildirin: IPAM bunlardan otomatik türetilir.',
      reserved: "TVirt'e ayrılan aralıklar",
      address: 'Adres',
      origin: 'Köken',
      origin_declared: 'bildirilen',
      origin_observed: 'gözlemlenen',
      holder: 'Tutan',
      noAddresses: 'Bu alt ağda bilinen adres yok.',
      sourceFabric: 'Fabric',
      sourceOverlay: 'Overlay',
      editAtSource: 'Kaynağında düzenle'
    },

    // Rete > Firewall (#168): il vocabolario dei gruppi + la terna per-NIC.
    firewall: {
      title: 'Güvenlik duvarı grupları',
      createTitle: 'Yeni güvenlik duvarı grubu',
      editTitle: 'Güvenlik duvarı grubunu düzenle',
      empty: "Henüz güvenlik duvarı grubu yok — bir tane oluşturun: konuk NIC'lerinden adla başvurulan, yeniden kullanılabilir bir kural dağarcığı.",
      nameHint: "Harfler, rakamlar ve içte . - _; kendi scope'u içinde benzersiz (başka yerlerdeki adaşlar /scope/ad ile ayırt edilir)",
      description: 'Açıklama',
      descriptionHint: 'Tek satırlık bir niyet; grubun seçildiği her yerde gösterilir',
      enforced: "Scope'ta zorunlu",
      enforcedHint: "Kapalı: salt dağarcık — kurallar yalnızca gruba başvuran NIC'leri bağlar. Açık: kurallar grubun scope'u altındaki güvenlik duvarı açık HER konuk NIC'ini bağlar, başvursun ya da başvurmasın.",
      enforcedChip: 'Zorunlu',
      enforcedChipHint: "Kurallar grubun scope'u altındaki güvenlik duvarı açık her konuk NIC'ini bağlar, başvursun ya da başvurmasın",
      enforceWarning: "Zorunlu kılmayı açmak, kuralları bir sonraki eşitlemede {scope} altındaki güvenlik duvarı açık HER konuk NIC'ine bağlar, açık bir başvuru olmasa bile — ve etkin bir chain içinde bir atanın drop'u kesindir: alttaki seviyeler onu yeniden açamaz.",
      unenforceInfo: "Zorunlu kılmayı kaldırınca kurallar yalnızca gruba açıkça başvuran NIC'lerde kalır.",
      rules: 'Kurallar',
      tabOverview: 'Genel bakış',
      tabRules: 'Kurallar',
      orderHint: 'Satır sırası, grup içindeki değerlendirme sırasının TA KENDİSİDİR: eşleşen ilk kural kazanır.',
      statefulHint: 'Stateful örtüktür: kabul edilen trafiğe verilen yanıtlar kendiliğinden geçer (established/related kabul edilir, invalid düşürülür — bunları motor enjekte eder, elle yazılmaz).',
      noRules: 'Kural yok — yapım aşamasında bir dağarcık: ona başvurmak meşrudur ve hiçbir şey üretmez.',
      addRule: 'Kural ekle',
      direction: 'Yön',
      directionIn: 'Gelen',
      directionOut: 'Giden',
      action: 'Eylem',
      action_accept: 'Kabul et',
      action_drop: 'Düşür',
      action_reject: 'Reddet',
      protocol: 'Protokol',
      protocolAny: 'Herhangi',
      ports: 'Portlar',
      source: 'Kaynak',
      dest: 'Hedef',
      comment: 'Yorum',
      addressHint: 'IPv4 CIDR ya da <fabric>/<mantıksal ağ>; boş = herhangi',
      moveUp: 'Yukarı taşı',
      moveDown: 'Aşağı taşı',
      nicFirewall: 'Güvenlik duvarı',
      nicAntiSpoof: 'Anti-spoofing',
      nicGroups: 'Güvenlik duvarı grupları',
      nicGroupsPlaceholder: 'Bir grup seçin…',
      nicGroupsHint: "Görünür gruplar, üst scope'larınkiler dahil (aşağı doğru kullanılabilir, etiketler gibi)",
      nicGroupCount: { one: '{n} güvenlik duvarı grubu', other: '{n} güvenlik duvarı grubu' },
      nicOff: 'Güvenlik duvarı kapalı',
      pendingRestartHint: "Güvenlik duvarı değişiklikleri kaydedilen/uygulanan modelini izler: bir sonraki power cycle'ı beklerler (PendingRestart). Üst scope'ların zorunlu kıldığı gruplar, NIC'in güvenlik duvarı açıkken uygulanır.",
      appConvergeHint: "Güvenlik duvarı değişiklikleri konteynerin bir sonraki eşitlemesinde uygulanır. Üst scope'ların zorunlu kıldığı gruplar güvenlik duvarı açıkken uygulanır.",
      enforcedAncestors: "Üst scope'lar tarafından zorunlu kılınanlar",
      enforcedAncestorsHint: "Bu grup, scope'u altındaki güvenlik duvarı AÇIK olan her NIC'e uygulanır — anahtar NIC'in ana anahtarıdır (kapalı = hiç chain yok, atalar dahil); etkin bir chain içinde atanın otoritesi kesindir: onun drop'u aşağıda yeniden açılmaz."
    }
  }
}
